import { debounce } from 'helpers/kuran'
import { useEffect, useState } from 'react'

export const ReadProgress = () => {
  const [width, setWidth] = useState(0)
  useEffect(() => {
    const myFunction = () => {
      var winScroll =
        document.body.scrollTop || document.documentElement.scrollTop
      var height =
        document.documentElement.scrollHeight -
        document.documentElement.clientHeight -
        88
      var scrolled = (winScroll / height) * 100
      setWidth(scrolled > 100 ? 100 : scrolled)
    }

    const myFun = debounce(myFunction, 100)

    window.addEventListener('scroll', myFun)

    return () => {
      window.removeEventListener('scroll', myFun)
    }
  }, [])
  return (
    <div style={{ width: `${width}%` }} className=" h-[3px] bg-lime-500">
      {' '}
    </div>
  )
}
